import { getPrioritizeNudgeTimestampKey } from '../constants';
import { getUserStore } from '../store/store';
import { type LocalStorageKeys, setItem } from 'owa-local-storage';
import { mutatorAction } from 'satcheljs';
import { PrioritizeRequestStatus } from '../store/PrioritizeRequestStatus';
import type { MailboxInfo } from 'owa-client-types';
import type { DebugOutput } from 'owa-copilot-shared/lib/models/DebugOutput';

export const updatePrioritizeRequestStatusMutator: (
    mailboxInfo: MailboxInfo,
    status?: PrioritizeRequestStatus,
    shouldUpdatePrioritizeNudgeTimestamp?: boolean,
    skippedRowKeys?: string[],
    debugOutput?: DebugOutput,
    hasUnprocessedRows?: boolean
) => void = mutatorAction(
    'updatePrioritizeRequestStatus',
    (
        mailboxInfo: MailboxInfo,
        status?: PrioritizeRequestStatus,
        shouldUpdatePrioritizeNudgeTimestamp?: boolean,
        skippedRowKeys?: string[],
        debugOutput?: DebugOutput,
        hasUnprocessedRows?: boolean
    ): void => {
        const store = getUserStore(mailboxInfo);

        store.requestNumber = store.requestNumber + 1;

        if (status === PrioritizeRequestStatus.InProgress) {
            store.loadingMessageIndex = 0;
            store.inProgressStartTimestamp = Date.now();
            store.readyShownTimestamp = undefined;
        } else if (status === PrioritizeRequestStatus.Ready) {
            store.inProgressStartTimestamp = undefined;
            store.readyShownTimestamp = Date.now();
        } else if (status !== undefined) {
            // None / Error / Nudged — clear both lifecycle timestamps
            store.inProgressStartTimestamp = undefined;
            store.readyShownTimestamp = undefined;
        }

        if (status !== undefined) {
            store.prioritizeRequestStatus = status;
        }

        if (shouldUpdatePrioritizeNudgeTimestamp) {
            setItem(
                window,
                getPrioritizeNudgeTimestampKey(mailboxInfo.mailboxSmtpAddress) as LocalStorageKeys,
                Date.now().toString()
            );
        }

        if (skippedRowKeys && skippedRowKeys.length > 0) {
            store.skippedRowKeys.push(...skippedRowKeys);
        }

        if (debugOutput) {
            store.debugOutput = debugOutput;
        }

        if (hasUnprocessedRows !== undefined) {
            store.hasUnprocessedRows = hasUnprocessedRows;
        }
    }
);
